import {addMultipleListeners} from '@weseus/cms-core/assets/js/helpers';

class AddToBasketInstance {
	constructor(block) {
		this.initialize(block);
	}

	initialize(block) {
		this.sumElement = block.querySelector('[product-price-sum]');
		this.sumTaxElement = block.querySelector('[product-price-tax-sum]');
		this.amountElement = block.querySelector('input[product-amount]');

		const metaLocale = block.querySelector('meta[property="og:locale"]');
		this.locale = metaLocale ? metaLocale.getAttribute('content').replace('_', '-') : 'cs-CZ';

		if (this.amountElement === null) {
			return;
		}

		if (!this.amountElement.hasAttribute('data-add-to-basket-initialized')) {
			this.plusElement = block.querySelectorAll('a[amount-plus], button[amount-plus]');
			this.minusElement = block.querySelectorAll('a[amount-minus], button[amount-minus]');

			this.price = parseFloat(this.amountElement.getAttribute('price'));
			this.priceTax = parseFloat(this.amountElement.getAttribute('price-tax'));
			this.priceDecimals = parseFloat(this.amountElement.getAttribute('price-decimals'));

			this.amountStep = parseFloat(this.amountElement.getAttribute('step'));
			this.amountMin = parseFloat(this.amountElement.getAttribute('min'));
			this.amountMax = parseFloat(this.amountElement.getAttribute('max'));

			this.initializePriceButtons(this.minusElement, true);
			this.initializePriceButtons(this.plusElement, false);

			this.amountElement.addEventListener('change', (e) => {
				this.amountElement.value = this.checkLimits(parseFloat(this.amountElement.value));
				this.calcPrice();
			});

			this.calcPrice();

			this.amountElement.setAttribute('data-add-to-basket-initialized', '1');
		}
	}

	initializePriceButtons(elements, minus = false) {
		for (let iMinus = 0; iMinus < elements.length; iMinus++) {
			addMultipleListeners(elements[iMinus], ['click', 'touch'], (e) => {
				e.preventDefault();
				let amount = 1;
				if (minus) {
					amount = parseFloat(this.amountElement.value) - this.amountStep;
				} else {
					amount = parseFloat(this.amountElement.value) + this.amountStep;
				}

				this.amountElement.value = this.checkLimits(amount);
				this.calcPrice();
			});
		}
	}

	calcPrice() {
		let amount = parseFloat(this.amountElement.value);

		let dec = Math.pow(10, this.priceDecimals);

		if (this.sumElement) {
			this.sumElement.innerHTML = parseFloat((Math.round(amount * this.price * dec) / dec).toFixed(this.priceDecimals)).toLocaleString(this.locale);
		}

		if (this.sumTaxElement) {
			this.sumTaxElement.innerHTML = parseFloat((Math.round(amount * this.priceTax * dec) / dec).toFixed(this.priceDecimals)).toLocaleString(this.locale);
		}
	}

	checkLimits(amount) {
		if (amount < this.amountMin) {
			amount = this.amountMin;
		} else if (amount > this.amountMax) {
			amount = this.amountMax;
		}

		let decimals = Math.pow(10, this.countDecimals(this.amountStep));
		amount = Math.round(amount * decimals) / decimals;

		return amount;
	}

	countDecimals(value) {
		if (Math.floor(value) === value) return 0;
		return value.toString().split(".")[1].length || 0;
	}
}

export default class AddToBasketExtension {
	constructor(naja) {
		naja.addEventListener('init', () => {
			new AddToBasketInstance(document);
		});

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			const snippetEl = document.getElementById(event.snippet.id);
			new AddToBasketInstance(snippetEl);
		});
	}
}